/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_OfficeInputs */

const cs_nav_section_office = /** @type {(inputs: Nav_Section_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kancelář`)
};

const en_nav_section_office = /** @type {(inputs: Nav_Section_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office`)
};

/**
* | output |
* | --- |
* | "Office" |
*
* @param {Nav_Section_OfficeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_office = /** @type {((inputs?: Nav_Section_OfficeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_OfficeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_office(inputs)
	return cs_nav_section_office(inputs)
});